
  import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SupplierPaymentApi } from '../api/supplierpayment.api';
import { switchMap, map } from 'rxjs/operators';

import { SupplierPaymentData, SupplierPayment } from '../../../interfaces/masters/supplierpayment' ;
@Injectable()
export class SupplierPaymentService extends SupplierPaymentData {

    constructor(private api: SupplierPaymentApi) {
      super();
    }
  
  
    list(url: string): Observable<SupplierPayment[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<any>{
        return this.api.getById(url);
    }
  
    create(url: string, data:any): Observable<SupplierPayment[]> {
      return this.api.add(url,data);
    }
  
  updateSupPaymentDet(url: string, data:any): Observable<any> {
    debugger;
      return this.api.updateSupPaymentDet(url,data);
    }
    update(url: string, data:SupplierPayment): Observable<SupplierPayment> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  